

































import Vue from "vue";
import _ from "lodash";
import RichEditor from "@/components/editor/rich-editor.vue";

const ItemMapper = (
    plan = {}
): { studentPhotos: { downloadUrl: string; thumbnailUrl: string; fileKey: string }[]; introduction: string } => {
    return {
        introduction: _.get(plan, "introduction.introduction", ""),
        studentPhotos: _.get(plan, "introduction.studentPhotos", [])
    };
};
export default Vue.extend({
    name: "Introduction",
    components: { RichEditor },
    props: {
        plan: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showPreview: false,
            previewIndex: 0
        };
    },
    computed: {
        item(): any {
            return ItemMapper(this.plan);
        },
        images(): any {
            return _.map(_.get(this.plan, "introduction.studentPhotos", []), photo => photo.downloadUrl);
        }
    },
    methods: {
        preview(index) {
            this.onClickPreview();
            this.showPreview = true;
            this.previewIndex = index;
        },
        onClickPreview(): void {
            this.$router.push({ path: this.$route.path, hash: "preview" }).catch();
        },
        onClosePreview(): void {
            if (this.$route.hash === "#preview") {
                this.$router.back();
            }
        }
    }
});
